module.exports = __webpack_public_path__ + "static/media/nlbLogo.01daf67b.png";